<template>
    <div>
        <v-row v-if="registrationObj.events.length > 0" class="mr-1">
            <v-col cols="12" md="12" class="text-left pb-0">
                <p class="mb-0">{{ $t("registerEvent.step_2_subtitle") }}</p>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="text-left">
                <v-text-field
                    :label="$t('registerEvent.step_2_label_box')"
                    :hint="$t('registerEvent.step_2_hint_box')"
                    persistent-hint
                    outlined dense
                    v-model="searchEvent"
                ></v-text-field>
            </v-col>
        </v-row>
        <!-- card results -->
        <template>
            <v-row justify="center">
                <v-col cols="12" sm="12" v-if="eventItemsFiltered.length > 0">

                    <v-row>
                        <v-col cols="12" class="text-left">
                            <template>
                              <v-tabs
                                v-model="eventsTab"
                                center-active
                                next-icon="mdi-arrow-right-bold-box-outline"
                                prev-icon="mdi-arrow-left-bold-box-outline"
                                show-arrows
                              >
                                <v-tab tab-value="registration">{{$t('registerEvent.tabs.registration')}}</v-tab>
                                <v-tab tab-value="address">{{$t('registerEvent.tabs.address')}}</v-tab>
                                <v-tab tab-value="pricing">{{$t('registerEvent.tabs.pricing')}}</v-tab>
                                <v-tab tab-value="calendar" >{{$t('registerEvent.tabs.calendar')}}</v-tab>
                              </v-tabs>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row v-show="eventsTab == 'calendar'">
                      <v-col>
                        <Calendar 
                          ref="calendarDay" 
                          :eventsCalendar="calendarEvents" 
                          typeCalendar="store" 
                          :registrationObj="registrationObj"
                          :promoterId="registrationObj.promoterSel ? registrationObj.promoterSel.promoterId : 0"
                          @handleEventClick="handleEventClick"
                        ></Calendar>
                    
                      </v-col>
                    </v-row>
                    <!-- Cards -->
                    <v-row  v-if="eventsTab != 'calendar'">
                      <v-col
                        v-for="(item) in eventItemsFiltered"
                        :key="`card-event-${item.id}`"
                        cols="12"
                      >
                        <v-card :style="`background: ${colorCard}`">
                          <div class="d-flex flex-no-wrap justify-space-between" :style="{ minHeight: (windowWidth >= 600) ? '174px' : '100px' }">
                            <v-avatar
                              class="ma-3"
                              :size="windowWidth < 600 ? 80 : 150"
                              tile
                              style="margin-top: auto !important; margin-bottom: auto !important;"
                            >
                              <ImageCard :src="`${urlDomain}/${item.eventImage}`" :urlImage="item.eventImage" class="img-resp" />
                            </v-avatar>
                            <div style="width: 100%" v-if="windowWidth >= 600">
                              <v-card-title
                                style="padding: 6px 16px 16px;"
                              >
                                {{item.eventName}} 
                                <span v-if="registrationObj.promoterSel.userID != item.userId" style="color: red" class="ml-sm-2 ml-0"> ({{$t('registerEvent.by')}} {{item.promoterName}})</span>
                              </v-card-title>
                              <v-card-subtitle class="pb-0">
                                {{item.eventDate|formatDateForHumans(false)}}
                                <strong v-if="item.showRegistrationCountdown == 1 || item.type == 'close'">
                                  <Timer
                                    :stylec="0" 
                                    v-if="item.type == 'now'" 
                                    :starttime="item.nowDate"
                                    :endtime="item.regClose" 
                                    :labeltime="$t('registerEvent.open_left_time')"
                                    :classh="1" :type="item.type" :step="2"
                                    @changeType="changeType(item)"
                                  ></Timer>
                                  <Timer
                                    :stylec="0" 
                                    v-if="item.type == 'soon'" 
                                    :starttime="item.nowDate"
                                    :endtime="item.regOpen" 
                                    :labeltime="$t('registerEvent.opens_in')"
                                    :classh="0" :type="item.type" :step="2"
                                    @changeType="changeType(item)"
                                  ></Timer>
                                  <Timer
                                    :stylec="0" 
                                    v-if="item.type == 'close'" 
                                    :starttime="item.nowDate"
                                    :endtime="item.regClose" 
                                    :labeltime="$t('registerEvent.opens_in')"
                                    :classh="0" :type="item.type" :step="2"
                                    @changeType="changeType(item)"
                                  ></Timer>
                                </strong>
                                <p v-if="userAge < item.adultAge" style="color: red;">{{ $t('registerEvent.adult_age_error', { age: item.adultAge }) }}</p>
                              </v-card-subtitle>
                              <v-card-actions>
                                  <v-btn
                                      v-if="userAge >= item.adultAge"
                                      :color="`${buttonColor}`"
                                      :class="`btn_next ${ canRegisterEvent(item) ? '' : 'disabledCust'}`"
                                      @click="selectEvent(item)"
                                      :loading="item.loading"
                                      :disabled="item.disabled || !canRegisterEvent(item)"
                                  >{{ canRegisterEvent(item) ? $t("registerEvent.register") : $t("registerEvent.event_full") }}</v-btn>
                              </v-card-actions>
                              
                              <v-card-text style="padding: 16px 16px 24px;">
                                <v-row v-if="eventsTab == 'registration'">
                                  <v-col class="font-weight-bold pt-0">
                                    {{$t('registerEvent.open_reg')}}
                                  </v-col>
                                  <v-col class="font-weight-bold pt-0">
                                    {{$t('registerEvent.close_reg')}}
                                  </v-col>
                                  <v-col v-if="item.showTotalRegistered == 1" class="font-weight-bold pt-0">
                                    {{$t('registerEvent.total_reg')}}
                                  </v-col>
                                  <v-col v-if="item.showTotalRegistered == 1 || item.showTotalRegistered == 2" class="font-weight-bold pt-0">
                                    {{$t('registerEvent.open_left')}}
                                  </v-col>
                                </v-row>
                                <v-row v-if="eventsTab == 'registration'">
                                  <v-col style="padding: 0px 12px">{{item.registrationOpen|formatDateForHumans}}</v-col>
                                  <v-col style="padding: 0px 12px">{{item.registrationClose|formatDateForHumans}}</v-col>
                                  <v-col v-if="item.showTotalRegistered == 1" style="padding: 0px 12px">{{item.totalReg}}</v-col>
                                  <v-col v-if="item.showTotalRegistered == 1 || item.showTotalRegistered == 2" style="padding: 0px 12px">{{item.leftOpen}}</v-col>
                                </v-row>
                                <v-row v-if="eventsTab == 'description'">
                                  <v-col v-if="item.eventDescription != ''" v-html="item.eventDescription" />
                                </v-row>
                                <v-row v-if="eventsTab == 'address'">
                                  <v-col xs="12" sm="12" md="12" v-if="item.address != ''"><strong>{{$t('registerEvent.address')}}</strong>: {{item.address}}</v-col>
                                  <v-col xs="12" sm="6" md="3" v-if="item.city != ''"><strong>{{$t('registerEvent.city')}}</strong>: {{item.city}}</v-col>
                                  <v-col xs="12" sm="6" md="3" v-if="item.state != ''"><strong>{{$t('registerEvent.state')}}</strong>: {{item.state}}</v-col>
                                  <v-col xs="12" sm="6" md="3" v-if="item.country != ''"><strong>{{$t('registerEvent.country')}}</strong>: {{item.country}}</v-col>
                                  <v-col xs="12" sm="6" md="3" v-if="item.zip != ''"><strong>{{$t('registerEvent.zip')}}</strong>: {{item.zip}}</v-col>
                                </v-row>

                                <v-row v-if="eventsTab == 'pricing'">
                                      <v-col sm="6" v-if="item.regFee > 0"><strong>{{$t('registerEvent.simple-cost')}}</strong>: {{ formatCurrency(item.regFee, item.currency) }}</v-col>
                                      <v-col sm="6" v-if="item.eventRegistrationPrice.price > 0"><strong>{{$t('registerEvent.event-price')}}</strong>: {{ formatCurrency(item.eventRegistrationPrice.price, item.currency) }}<span v-if="item.eventRegistrationPrice.isPerClass">/class</span></v-col>
                                      <v-col sm="6" v-if="item.eventSpectatorPrice.price > 0"><strong>{{$t('registerEvent.gate-fee')}}</strong>: {{ formatCurrency(item.eventSpectatorPrice.price, item.currency) }}</v-col>
                                      <v-col cols="12" v-if="groupRaceClasses(item.raceClasses).length > 0">
                                        <v-row>
                                          <v-col cols="12">
                                              <v-row>
                                                <v-col cols="3" md="2"><strong>{{$t('registerEvent.fee')}}</strong></v-col>
                                                <v-col cols="9" md="10"><strong>{{$t('registerEvent.class')}}</strong></v-col>
                                              </v-row>
                                            <div v-for="(classGroup, index) in groupRaceClasses(item.raceClasses)" :key="index">
                                              <v-row>
                                                <v-col cols="3" md="2">
                                                  <span v-if="classGroup.addedFee < 0">{{ `${formatCurrency(Math.abs(classGroup.addedFee), item.currency)} ${$t('common.off')}` }}</span>
                                                  <span v-if="classGroup.addedFee == 0">N/A</span>
                                                  <span v-if="classGroup.addedFee > 0">+{{ formatCurrency(classGroup.addedFee, item.currency) }}</span>
                                                </v-col>
                                                <v-col cols="9" md="10">
                                                  <span v-for="(c, i) in classGroup.classes" :key="i">
                                                    <span v-if="classGroup.addedFee != 0">
                                                      <span>{{ c.name }}</span>
                                                      <span v-if="i < (classGroup.classes.length - 1)">, </span>
                                                    </span>
                                                  </span>
                                                </v-col>
                                              </v-row>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" v-if="getRaceClassesWithTiers(item.raceClasses).length > 0">
                                        <strong>{{$t('registerEvent.dynamic-pricing-tiers')}}</strong>
                                        <div
                                          v-for="raceClass in getRaceClassesWithTiers(item.raceClasses)"
                                          :key="`tier-desktop-${item.id}-${raceClass.id}`"
                                          class="mt-1"
                                        >
                                          <div><strong>{{ raceClass.name }}</strong></div>
                                          <div
                                            v-for="tier in raceClass.dynamicPriceTiers"
                                            :key="`tier-desktop-${item.id}-${raceClass.id}-${tier.id || tier.daysBeforeEvent}`"
                                          >
                                            {{ tier.daysBeforeEvent }} {{$t('registerEvent.days-before-event')}}: {{ formatCurrency(tier.price, item.currency) }}
                                          </div>
                                        </div>
                                      </v-col>
                                      <v-col cols="12" v-if="item.eventLevelPrices.length > 0">
                                        <strong>{{$t('registerEvent.level-pricing')}}</strong>: 
                                        <span v-for="(lp, i) in item.eventLevelPrices" :key="i">
                                          <span>{{ lp.level | addOrdinalSuffix }} {{$t('registerEvent.class').toLowerCase()}} {{ formatCurrency(lp.price, item.currency) }}</span>
                                          <span v-if="i < (item.eventLevelPrices.length - 1)">, </span><span v-else>.</span>
                                        </span>
                                      </v-col>
                                    </v-row>

                              </v-card-text>

                            </div>
                          </div>

                            <div class="d-flex flex-no-wrap justify-space-between" v-if="windowWidth < 600">
                              <div style="width: 100%">
                                  <v-card-title
                                    style="padding: 6px 16px 16px;"
                                    v-if="windowWidth >= 500"
                                  >
                                    {{item.eventName}} <br>
                                    <span v-if="registrationObj.promoterSel.userID != item.userId" style="color: red" class="ml-2">({{$t('registerEvent.by')}} {{item.promoterName}})</span>
                                  </v-card-title>
                                  <v-card-subtitle class="pb-0" v-if="windowWidth >= 500">
                                    {{item.eventDate}}
                                    <strong v-if="item.showRegistrationCountdown == 1">
                                      <Timer
                                        :stylec="0" v-if="item.type == 'now'" :starttime="item.nowDate"
                                        :endtime="item.regClose" :labeltime="$t('registerEvent.open_left_time')"
                                        :classh="1" :type="item.type" :step="2"
                                        @changeType="changeType(item)"
                                      ></Timer>
                                      <Timer
                                        :stylec="0" v-if="item.type == 'soon'" :starttime="item.nowDate"
                                        :endtime="item.regOpen" :labeltime="$t('registerEvent.opens_in')"
                                        :classh="0" :type="item.type" :step="2"
                                        @changeType="changeType(item)"
                                      ></Timer>
                                      <Timer
                                        :stylec="0" v-if="item.type == 'close'" :starttime="item.nowDate"
                                        :endtime="item.regClose" :labeltime="$t('registerEvent.opens_in')"
                                        :classh="0" :type="item.type" :step="2"
                                        @changeType="changeType(item)"
                                      ></Timer>
                                    </strong>
                                    <p v-if="userAge < item.adultAge" style="color: red;">{{ $t('registerEvent.adult_age_error', { age: item.adultAge }) }}</p>
                                  </v-card-subtitle>
                                  <v-card-text style="padding: 16px 16px 24px;" v-if="windowWidth >= 500">
                                    <v-row v-if="eventsTab == 'registration'">
                                      <v-col class="font-weight-bold pt-0">
                                        {{$t('registerEvent.open_reg')}}
                                      </v-col>
                                      <v-col class="font-weight-bold pt-0">
                                        {{$t('registerEvent.close_reg')}}
                                      </v-col>
                                      <v-col v-if="item.showTotalRegistered == 1" class="font-weight-bold pt-0">
                                        {{$t('registerEvent.total_reg')}}
                                      </v-col>
                                      <v-col v-if="item.showTotalRegistered == 1 || item.showTotalRegistered == 2" class="font-weight-bold pt-0">
                                        {{$t('registerEvent.open_left')}}
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'registration'">
                                      <v-col style="padding: 0px 12px">{{item.registrationOpen}}</v-col>
                                      <v-col style="padding: 0px 12px">{{item.registrationClose}}</v-col>
                                      <v-col v-if="item.showTotalRegistered == 1" style="padding: 0px 12px">{{item.totalReg}}</v-col>
                                      <v-col v-if="item.showTotalRegistered == 1 || item.showTotalRegistered == 2" style="padding: 0px 12px">{{item.leftOpen}}</v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'description'">
                                      <v-col v-if="item.eventDescription != ''" v-html="item.eventDescription" />
                                    </v-row>
                                    <v-row v-if="eventsTab == 'address'">
                                      <v-col cols="12" v-if="item.address != ''"><strong>{{$t('registerEvent.address')}}</strong>: {{item.address}}</v-col>
                                      <v-col cols="6" v-if="item.city != ''"><strong>{{$t('registerEvent.city')}}</strong>: {{item.city}}</v-col>
                                      <v-col cols="6" v-if="item.state != ''"><strong>{{$t('registerEvent.state')}}</strong>: {{item.state}}</v-col>
                                      <v-col cols="6" v-if="item.country != ''"><strong>{{$t('registerEvent.country')}}</strong>: {{item.country}}</v-col>
                                      <v-col cols="6" v-if="item.zip != ''"><strong>{{$t('registerEvent.zip')}}</strong>: {{item.zip}}</v-col>
                                    </v-row>

                                    <v-row v-if="eventsTab == 'pricing'">
                                      <v-col cols="12" v-if="item.regFee != 0"><strong>{{$t('registerEvent.simple-cost')}}</strong>: {{ formatCurrency(item.regFee, item.currency) }}</v-col>
                                      <v-col cols="12" v-if="item.eventRegistrationPrice.price != 0"><strong>{{$t('registerEvent.event-price')}}</strong>: {{ formatCurrency(item.eventRegistrationPrice.price, item.currency) }}<span v-if="item.eventRegistrationPrice.isPerClass">/class</span></v-col>
                                      <v-col cols="12" v-if="item.eventSpectatorPrice.price != 0"><strong>{{$t('registerEvent.gate-fee')}}</strong>: {{ formatCurrency(item.eventSpectatorPrice.price, item.currency) }}</v-col>
                                      <v-col cols="12" v-if="groupRaceClasses(item.raceClasses).length > 0">
                                        <v-row>
                                          <v-col cols="12">
                                              <v-row>
                                                <v-col cols="3"><strong>{{$t('registerEvent.fee')}}</strong></v-col>
                                                <v-col cols="9"><strong>{{$t('registerEvent.class')}}</strong></v-col>
                                              </v-row>
                                            <div v-for="(classGroup, index) in groupRaceClasses(item.raceClasses)" :key="index">
                                              <v-row>
                                                <v-col cols="3">
                                                  <span v-if="classGroup.addedFee < 0">{{ `${formatCurrency(Math.abs(classGroup.addedFee), item.currency)} ${$t('common.off')}` }}</span>
                                                  <span v-if="classGroup.addedFee == 0">N/A</span>
                                                  <span v-if="classGroup.addedFee > 0">+{{ formatCurrency(classGroup.addedFee, item.currency) }}</span>
                                                </v-col>
                                                <v-col cols="9">
                                                  <span v-for="(c, i) in classGroup.classes" :key="i">
                                                    <span v-if="classGroup.addedFee != 0">
                                                      <span>{{ c.name }}</span>
                                                      <span v-if="i < (classGroup.classes.length - 1)">, </span>
                                                    </span>
                                                  </span>
                                                </v-col>
                                              </v-row>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" v-if="getRaceClassesWithTiers(item.raceClasses).length > 0">
                                        <strong>{{$t('registerEvent.dynamic-pricing-tiers')}}</strong>
                                        <div
                                          v-for="raceClass in getRaceClassesWithTiers(item.raceClasses)"
                                          :key="`tier-mobile-md-${item.id}-${raceClass.id}`"
                                          class="mt-1"
                                        >
                                          <div><strong>{{ raceClass.name }}</strong></div>
                                          <div
                                            v-for="tier in raceClass.dynamicPriceTiers"
                                            :key="`tier-mobile-md-${item.id}-${raceClass.id}-${tier.id || tier.daysBeforeEvent}`"
                                          >
                                            {{ tier.daysBeforeEvent }} {{$t('registerEvent.days-before-event')}}: {{ formatCurrency(tier.price, item.currency) }}
                                          </div>
                                        </div>
                                      </v-col>
                                      <v-col cols="12" v-if="item.eventLevelPrices.length > 0">
                                        <strong>{{$t('registerEvent.level-pricing')}}</strong>: 
                                        <span v-for="(lp, i) in item.eventLevelPrices" :key="i">
                                          <span>{{ lp.level | addOrdinalSuffix }} {{$t('registerEvent.class').toLowerCase()}} {{ formatCurrency(lp.price, item.currency) }}</span>
                                          <span v-if="i < (item.eventLevelPrices.length - 1)">, </span><span v-else>.</span>
                                        </span>
                                      </v-col>
                                    </v-row>

                                    <v-row>
                                      <v-col class="pt-0">
                                        <v-btn
                                          v-if="userAge >= item.adultAge"
                                          :color="`${buttonColor}`"
                                          :class="`btn_next next_rsp ${ canRegisterEvent(item) ? '' : 'disabledCust'}`"
                                          @click="selectEvent(item)"
                                          :loading="item.loading"
                                          :disabled="item.disabled || !canRegisterEvent(item)"
                                        >{{ canRegisterEvent(item) ? $t("registerEvent.register") : $t("registerEvent.event_full") }}</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                  
                                  <v-card-text 
                                    v-else
                                    style="padding: 16px 16px 24px;" 
                                  >
                                    <v-card-title
                                      style="padding: 6px 0 16px;"
                                    >
                                      {{item.eventName}} <br>
                                      <span v-if="registrationObj.promoterSel.userID != item.userId" style="color: red" class="ml-sm-2 ml-0">({{$t('registerEvent.by')}} {{item.promoterName}})</span>
                                    </v-card-title>
                                    <v-row>
                                      <v-col class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.event_date')}}: </span>
                                        {{item.eventDate|formatDateForHumans(false)}}
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'registration'">
                                      <v-col class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.open_reg')}}: </span>
                                        {{item.registrationOpen|formatDateForHumans(false)}}
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'registration'">
                                      <v-col class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.close_reg')}}: </span>
                                        {{item.registrationClose|formatDateForHumans(false)}}
                                      </v-col>
                                    </v-row>
                                    <v-row >
                                      <v-col class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.open_left_time')}}: </span>
                                        <strong v-if="item.showRegistrationCountdown == 1">
                                          <Timer
                                            :stylec="0" v-if="item.type == 'now'" :starttime="item.nowDate"
                                            :endtime="item.regClose" :labeltime="$t('registerEvent.open_left_time')"
                                            :classh="1" :type="item.type" :step="2"
                                            @changeType="changeType(item)"
                                          ></Timer>
                                          <Timer 
                                            :stylec="0" v-if="item.type == 'soon'" :starttime="item.nowDate"
                                            :endtime="item.regOpen" :labeltime="$t('registerEvent.opens_in')"
                                            :classh="0" :type="item.type" :step="2"
                                            @changeType="changeType(item)"
                                          ></Timer>
                                          <Timer 
                                            :stylec="0" v-if="item.type == 'close'" :starttime="item.nowDate"
                                            :endtime="item.regClose" :labeltime="$t('registerEvent.opens_in')"
                                            :classh="0" :type="item.type" :step="2"
                                            @changeType="changeType(item)"
                                          ></Timer>
                                        </strong>
                                        <p v-if="userAge < item.adultAge" style="color: red;">{{ $t('registerEvent.adult_age_error', { age: item.adultAge }) }}</p>
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'registration'">
                                      <v-col v-if="item.showTotalRegistered == 1" class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.total_reg')}}: </span>
                                        {{item.totalReg}}
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'registration' && (item.showTotalRegistered == 1 || item.showTotalRegistered == 2)">
                                      <v-col class="pt-0">
                                        <span class="font-weight-bold">{{$t('registerEvent.open_left')}}: </span>
                                        {{item.leftOpen}}
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'description'">
                                      <v-col v-if="item.eventDescription != ''" v-html="item.eventDescription" />
                                    </v-row>
                                    <v-row v-if="eventsTab == 'address'">
                                      <v-col cols="12" v-if="item.address != ''"><strong>{{$t('registerEvent.address')}}</strong>: {{item.address}}</v-col>
                                      <v-col cols="12" v-if="item.city != ''"><strong>{{$t('registerEvent.city')}}</strong>: {{item.city}}</v-col>
                                      <v-col cols="12" v-if="item.state != ''"><strong>{{$t('registerEvent.state')}}</strong>: {{item.state}}</v-col>
                                      <v-col cols="12" v-if="item.country != ''"><strong>{{$t('registerEvent.country')}}</strong>: {{item.country}}</v-col>
                                      <v-col cols="12" v-if="item.zip != ''"><strong>{{$t('registerEvent.zip')}}</strong>: {{item.zip}}</v-col>
                                    </v-row>
                                    <v-row v-if="eventsTab == 'pricing'">
                                      <v-col cols="12" v-if="item.regFee != 0"><strong>{{$t('registerEvent.simple-cost')}}</strong>: {{ formatCurrency(item.regFee, item.currency) }}</v-col>
                                      <v-col cols="12" v-if="item.eventRegistrationPrice.price != 0"><strong>{{$t('registerEvent.event-price')}}</strong>: {{ formatCurrency(item.eventRegistrationPrice.price, item.currency) }}<span v-if="item.eventRegistrationPrice.isPerClass">/class</span></v-col>
                                      <v-col cols="12" v-if="item.eventSpectatorPrice.price != 0"><strong>{{$t('registerEvent.gate-fee')}}</strong>: {{ formatCurrency(item.eventSpectatorPrice.price, item.currency) }}</v-col>
                                      <v-col cols="12" v-if="groupRaceClasses(item.raceClasses).length > 0">
                                        <v-row>
                                          <v-col cols="12">
                                              <v-row>
                                                <v-col cols="3"><strong>{{$t('registerEvent.fee')}}</strong></v-col>
                                                <v-col cols="9"><strong>{{$t('registerEvent.class')}}</strong></v-col>
                                              </v-row>
                                            <div v-for="(classGroup, index) in groupRaceClasses(item.raceClasses)" :key="index">
                                              <v-row>
                                                <v-col cols="3">
                                                  <span v-if="classGroup.addedFee < 0">{{ `${formatCurrency(Math.abs(classGroup.addedFee), item.currency)} ${$t('common.off')}` }}</span>
                                                  <span v-if="classGroup.addedFee == 0">N/A</span>
                                                  <span v-if="classGroup.addedFee > 0">+{{ formatCurrency(classGroup.addedFee, item.currency) }}</span>
                                                </v-col>
                                                <v-col cols="9">
                                                  <span v-for="(c, i) in classGroup.classes" :key="i">
                                                    <span v-if="classGroup.addedFee != 0">
                                                      <span>{{ c.name }}</span>
                                                      <span v-if="i < (classGroup.classes.length - 1)">, </span>
                                                    </span>
                                                  </span>
                                                </v-col>
                                              </v-row>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" v-if="getRaceClassesWithTiers(item.raceClasses).length > 0">
                                        <strong>{{$t('registerEvent.dynamic-pricing-tiers')}}</strong>
                                        <div
                                          v-for="raceClass in getRaceClassesWithTiers(item.raceClasses)"
                                          :key="`tier-mobile-sm-${item.id}-${raceClass.id}`"
                                          class="mt-1"
                                        >
                                          <div><strong>{{ raceClass.name }}</strong></div>
                                          <div
                                            v-for="tier in raceClass.dynamicPriceTiers"
                                            :key="`tier-mobile-sm-${item.id}-${raceClass.id}-${tier.id || tier.daysBeforeEvent}`"
                                          >
                                            {{ tier.daysBeforeEvent }} {{$t('registerEvent.days-before-event')}}: {{ formatCurrency(tier.price, item.currency) }}
                                          </div>
                                        </div>
                                      </v-col>
                                      <v-col cols="12" v-if="item.eventLevelPrices.length > 0">
                                        <strong>{{$t('registerEvent.level-pricing')}}</strong>: 
                                        <span v-for="(lp, i) in item.eventLevelPrices" :key="i">
                                          <span>{{ lp.level | addOrdinalSuffix }} {{$t('registerEvent.class').toLowerCase()}} {{ formatCurrency(lp.price, item.currency) }}</span>
                                          <span v-if="i < (item.eventLevelPrices.length - 1)">, </span><span v-else>.</span>
                                        </span>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col class="pt-0">
                                        <v-btn
                                          v-if="userAge >= item.adultAge"
                                          :color="`${buttonColor}`"
                                          :class="`btn_next next_rsp ${ canRegisterEvent(item) ? '' : 'disabledCust'}`"
                                          @click="selectEvent(item)"
                                          :loading="item.loading"
                                          :disabled="item.disabled || !canRegisterEvent(item)"
                                        >{{ canRegisterEvent(item) ? $t("registerEvent.register") : $t("registerEvent.event_full") }}</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                              </div>
                            </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <!-- End Cards -->
                </v-col>
                <v-col cols="12" sm="12" v-else>
                  <WarningAlert>
                    {{ $t("registerEvent.step_1_hint_empty") }}
                  </WarningAlert>
                </v-col>
            </v-row>
        </template>
        <v-row>
            <v-col class="text-left my-1" cols="12">
                <v-btn v-if="!defaultRegistration"
                    :color="`${buttonColor}`"
                    class="btn_next"
                    v-model="step"
                    @click="nextStep(1);registrationObj.eventSel = null;registrationObj.events = [];"
                >{{ $t("registerEvent.prev") }}</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {
    VRow, VCol, VTextField, VBtn, VCard, VAvatar, VCardTitle, VCardActions, VCardText, VCardSubtitle, VTabs, VTab
} from 'vuetify/lib';
import Timer from "@/components/timer/Timer.vue";
import GeneralService from "@/services/GeneralService";
import ImageCard from "@/components/ImageCard";
import Calendar from "@/components/calendar/CalendarDay";
import { mapState } from 'vuex';
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
    components: {
      VRow, VCol, VTextField, VBtn, VCard, VAvatar, VCardTitle, VCardActions, VCardText, VCardSubtitle,
      Timer, ImageCard, VTabs, VTab, WarningAlert,
      Calendar
    },
    props: {
        windowWidth: Number,
        step: Number,
        registrationObj: Object,
        defaultRegistration: Boolean,
        defaultPromoterId: Array,
        userAge: Number
    },
    data() {
        return {
            buttonColor: "#000",
            searchEvent: "",
            reserved: 0,
            eventsTab: 'registration',
            calendar: '',
            calendarType: 'month',
            today: '',
            bandResetCalendar: false
        }
    },
    watch: {
      eventsTab(val) {
        this.initCalendar(!this.bandResetCalendar);
        if(val == 'calendar') this.bandResetCalendar = true;
      },
      regstep(val){
        if(val == 2){
          this.initCalendar();
        }
      }
    },
    computed: {
      regstep() {
        return this.registrationObj.step
      },
      calendarTypeLbl() {
          switch (this.calendarType) {
            case 'day':
              return this.$t('profile.day');
          
            default:
              return this.$t('profile.month');
          }
      },
      eventItemsFiltered: function() {
            return this.registrationObj.events.filter(event =>{
                return event.eventName.toLowerCase().includes(this.searchEvent.toLowerCase())
            })
      },
      ...mapState({
          colorCard: (state) => state.env.get('VUE_APP_COLOR_CARD'),
          urlDomain: (state) => state.env.get('VUE_APP_ROOT')
      }),
      calendarEvents () {
          let events = [];

          if(this.eventItemsFiltered.length == 0) {
            return events;
          }

          this.eventItemsFiltered.forEach((event) => {

            const e = { ...event };
            e.name = event.eventName;
            e.color = event.colorCode || '#000';

            e.start = this.formatDate(new Date(e.eventDate));
            e.end = this.formatDate(new Date(e.eventEndDate));
            events.push(e)
            
            const er = { ...e };
            er.start = this.formatDate(new Date(er.registrationOpen));
            er.end = this.formatDate(new Date(er.registrationClose));
            events.push(er)
          });

          return events;
      },
      calendarTitle() {
          return this.getCalendarTitle();
      },
      locale () {
          return this.$i18n.locale;
      }
    },
    methods: {
      initCalendar(bandReset = false) {
        if(this.$refs.calendarDay) this.$refs.calendarDay.Init(bandReset);
      },
      viewDay ({ date }) {
        this.calendar = date
        this.calendarType = 'day'
      },
      groupRaceClasses(raceClasses) {
        const groupedByFeeArray = [];
        const classesWithResolvedFee = Array.isArray(raceClasses)
          ? raceClasses.filter((raceClass) => parseFloat(raceClass.addedFee) !== 0)
          : [];

        // Iterar sobre el array de objetos
        classesWithResolvedFee.forEach(raceClass => {
            const addedFee = raceClass.addedFee;

            // Verificar si ya existe una entrada para el addedFee
            const existingEntry = groupedByFeeArray.find(entry => entry.addedFee === addedFee);

            if (existingEntry) {
                // Si ya existe, agregar el objeto actual al array correspondiente
                existingEntry.classes.push(raceClass);
            } else {
                // Si no existe, crear una nueva entrada en el array
                groupedByFeeArray.push({
                    addedFee: addedFee,
                    classes: [raceClass]
                });
            }
        });

        return groupedByFeeArray.sort((a, b) => a.addedFee - b.addedFee);
      },
      getRaceClassesWithTiers(raceClasses) {
        if (!Array.isArray(raceClasses)) return [];

        return raceClasses
          .filter((raceClass) => Array.isArray(raceClass.dynamicPriceTiers) && raceClass.dynamicPriceTiers.length > 0)
          .map((raceClass) => ({
            ...raceClass,
            dynamicPriceTiers: [...raceClass.dynamicPriceTiers].sort(
              (a, b) => parseInt(b.daysBeforeEvent, 10) - parseInt(a.daysBeforeEvent, 10)
            )
          }));
      },
      formatTierPrice(price) {
        const numericPrice = parseFloat(price);
        return Number.isFinite(numericPrice) ? numericPrice.toFixed(2) : '0.00';
      },
      formatCurrency(value, currencyCode) {
        const code = String(currencyCode || 'USD').toUpperCase();
        const amount = Number(value);
        const normalizedAmount = Number.isFinite(amount) ? amount : 0;

        try {
          return new Intl.NumberFormat(this.$i18n.locale || undefined, {
            style: 'currency',
            currency: code,
            currencyDisplay: 'code'
          }).format(normalizedAmount);
        } catch (error) {
          return `${code} ${normalizedAmount.toFixed(2)}`;
        }
      },
      getCalendarTitle() {
        if (this.$refs.calendar && this.$refs.calendar.title) {
          // Verifica que la referencia y la propiedad title existan
          return this.$refs.calendar.title;
        }
        return '';
      },
      handleEventClick({ event }) {
        this.selectEvent(event);
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.calendar = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
        formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');

          return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        nextStep(step) {
            this.$emit('nextStep', step);
        },
        canRegisterEvent(item) {
          return Number(item.leftOpen || 0) > 0 || Number(item.isReserved || 0) > 0 || Number(item.isReservedNum || 0) > 0;
        },
        selectEvent(item) {
          this.$emit('updateLoad', { value: true, item });
          this.$emit('selectEvent', item);
        },
        loadImage(url) {
          const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
          return urlImage;
        },
        changeType(item) {
          if(item.type == 'soon') {
            item.type = 'now';
          } else if(item.type == 'now') {
            item.type = 'close';
          }
        }
    },
    created() {
      this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    }
}
</script>

<style>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg.disabledCust {
  background-color: rgba(255,82,82,0.8) !important
}
.img-resp .v-image__image {
  background-size: 100%;
}
</style>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}

#calendar-title {
  color: #1867c0;
  padding: 10px;
}
</style>
